"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProductsLoading = void 0;
var _productBox = require("@ori/product-box");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("../../constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ProductsLoading = (param)=>{
    let { items } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.ContentRowsRoot, {
        gridRowStyle: "1fr 1fr 1fr 1fr",
        children: Array.from({
            length: items
        }).map((_, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_productBox.ProductBoxSkeleton, {
                animation: "pulse",
                "data-testid": getTestId(_constants.PRODUCT_BOX_SKELETON)
            }, index))
    });
};
exports.ProductsLoading = ProductsLoading;
